import { Logger } from '@tencent/vft-common/logger';
export default new Logger('vft-component/LoginPanel');